import { render, staticRenderFns } from "./FhFooter.vue?vue&type=template&id=d4bd1854"
import script from "./FhFooter.vue?vue&type=script&lang=js"
export * from "./FhFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports